import { Tr, Td, Text, Box, useDisclosure} from "@chakra-ui/react";
import AllCustomersModal from "./AllCustomersModal";

const AllCustomersTableRow = ({ user, index }) => {
  const { isOpen, onOpen, onClose } = useDisclosure();

  const tdStyle = {
    fontFamily: "Roboto",
    color: "black",
  };

  return (
    <Tr key={user.id}>
      <Td style={tdStyle} fontSize={{base:"10px",md:"12px",tablet:"16px"}}>{index + 1}</Td>
      <Td style={tdStyle} fontSize={{base:"10px",md:"12px",tablet:"16px"}} display={"flex"} alignItems={"center"}>
        <Text>{user.name}</Text>
        {user?.isAvailable && (
          <Box bgColor={"green"} w={2} h={2} borderRadius={"50%"} ml={1}></Box>
        )}
      </Td>
      <Td style={tdStyle} fontSize={{base:"10px",md:"12px",tablet:"16px"}}>{user.phoneNumber}</Td>
      <Td style={tdStyle} fontSize={{base:"10px",md:"12px",tablet:"16px"}}>
        <Text
          cursor={"pointer"}
          color={"scarlet"}
          textDecor={"underline"}
          onClick={() => {
            onOpen();
          }}
        >
          View Details
        </Text>
      </Td>
      <AllCustomersModal
        user={user}
        isOpen={isOpen}
        onClose={onClose}
      />
    </Tr>
  );
};

export default AllCustomersTableRow;
